import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import styles from "./ButtonLink.module.scss";

interface IButtonLink {
  pathname: string;
  title: string;
  className?: string;
}

const ButtonLink = ({
  pathname,
  title,
  className,
}: IButtonLink): ReactElement => (
  <div className={`${styles.btnContainer} ${className}`}>
    <Link to={pathname}>
      <Button color="success">{title}</Button>
    </Link>
  </div>
);

export default ButtonLink;
